import i18n from "i18next";

export type AnimalType = "dogs" | "cats";

type MessagePool = "loading" | "error" | "noDogs" | "noCats";

function pickRandom(pool: MessagePool): string {
  const messages = i18n.t(`utils:funnyMessages.${pool}`, {
    returnObjects: true,
  }) as unknown;
  if (!Array.isArray(messages) || messages.length === 0) return "";
  return String(messages[Math.floor(Math.random() * messages.length)]);
}

export function getRandomLoadingMessage() {
  return pickRandom("loading");
}

export function getRandomErrorMessage() {
  return pickRandom("error");
}

export function getRandomNoAnimalsMessage(type: AnimalType) {
  return pickRandom(type === "cats" ? "noCats" : "noDogs");
}
